import { createFileRoute } from '@tanstack/react-router';

export interface Search {
  locationId?: string;
  triggerNewFormModal?: boolean;
  list?: 'forms' | 'packets';
  documentId?: string;
  packetId?: string; // `packetId` is supported for legacy reasons
}

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/library')({
  staticData: { team: 'forms' },
  validateSearch: (search: Search): Search => {
    return {
      triggerNewFormModal: search.triggerNewFormModal ? true : undefined,
      list: search.list,
      locationId: search.locationId,
      documentId: search.documentId,
      packetId: search.packetId,
    };
  },
});
